import React              from 'react';
import { useTheme, styled } from '@mui/material/styles';
import IconButton         from '@mui/material/IconButton';
import FirstPageIcon      from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft  from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon       from '@mui/icons-material/LastPage';
import { useTranslation } from 'react-i18next';
import TextField          from '@mui/material/TextField';
//import { TextField }      from '@mui/material';

// Use styled API instead of makeStyles for MUI v5 compatibility
const PaginationActionsRoot = styled('div')(({ theme }) => ({
	flexShrink: 0,
	marginLeft: theme.spacing(2.5),
}));

const TablePaginationActions = (props) => {
	const theme = useTheme();

	const { count, page, rowsPerPage, onPageChange } = props;
	const { t } = useTranslation();


	const handleFirstPageButtonClick = event => {
		onPageChange(event, 0);
	};

	const handleBackButtonClick = event => {
		onPageChange(event, page - 1);
	};

	const handleNextButtonClick = event => {
		onPageChange(event, page + 1);
	};

	const handleLastPageButtonClick = event => {
		onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
	};

	const onManuallyPageChange = (e) => {
		const max = Math.max(0, Math.ceil(count / rowsPerPage)) - 1;

		let requested = (parseInt(e.target.value) -1 ) || page;
		if (requested < 0) requested = 0;
		if (requested > max) requested = max;
		onPageChange(e, requested);
	};

	return (
        <PaginationActionsRoot>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label={t('first_page')}
                size="large">
				{theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
			</IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label={t('previous_page')}
                size="large">
				{theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
			</IconButton>
            <TextField
				size='small'
				value={page + 1}
				onChange={onManuallyPageChange}
				style={{ width: 'auto', padding:'12px' }}
				type='number'
				inputProps={
					{
						min: 0,
						max: Math.max(0, Math.ceil(count / rowsPerPage)),
						style:{textAlign:'center'}
					}
				}
			/>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label={t('next_page')}
                size="large">
				{theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
			</IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label={t('last_page')}
                size="large">
				{theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
			</IconButton>
        </PaginationActionsRoot>
    );
};

export default TablePaginationActions;
